import { removeLoggedIn, setLoggedIn } from "@/libs/token";
import { userRole } from "@/libs/global";
import { login } from "@/api/interface";
import router from "@/router";

export default {
    state: {
        user: null,
        userRole: null
    },
    getters: {
        loggedIn(state) {
            return !!state.user;
        }
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user;
        }
    },
    actions: {
        async login({ commit }, userInfo, vm) {
            let { data } = await login(userInfo).setConfig({
                validationForm: vm
            });
            // data.role && userRole(data.role);

            setLoggedIn("user-logged-in");
        },
        async logout({ dispatch }) {
            try {
                await logout().setConfig({ disableHandle401: true });
                dispatch("frontendLogout");
            } catch (e) {
                const { response: res } = e;
                // 如果退出时，返回 401，则直接前端退出就行
                if (res && res.status === 401) {
                    dispatch("frontendLogout");
                } else {
                    throw e;
                }
            }
        },
        async getUser({ commit }) {
            const { data } = await getUser().setConfig({
                disableLoginModal: true
            });
            commit("SET_USER", data);
        },
        frontendLogout() {
            removeLoggedIn();
            // 由于退出后，有一些状态清理麻烦，直接刷新页面
            window.location.href = router.resolve({ name: "login" }).href;
        }
    }
};
